import linkifyIt from 'linkify-it';
import decorateComponentWithProps from 'decorate-component-with-props';
import TextEditorLink from '../text-editor-link';

const linkify = linkifyIt();

export default function createLinkDecorator({ ignoredBlockTypes = [], theme, followLinks } = {}) {
  return {
    strategy: (contentBlock, callback) => {
      if (ignoredBlockTypes.indexOf(contentBlock.getType()) > -1) {
        return;
      }

      const links = linkify.match(contentBlock.get('text'));
      if (typeof links !== 'undefined' && links !== null) {
        for (let i = 0; i < links.length; i += 1) {
          callback(links[i].index, links[i].lastIndex);
        }
      }
    },
    component: decorateComponentWithProps(TextEditorLink, { theme, followLinks }),
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/decorators/create-link-decorator.js